import { render, staticRenderFns } from "./ExportButton.vue?vue&type=template&id=3456b39b&scoped=true&"
import script from "./ExportButton.vue?vue&type=script&lang=ts&"
export * from "./ExportButton.vue?vue&type=script&lang=ts&"
import style0 from "./ExportButton.vue?vue&type=style&index=0&id=3456b39b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3456b39b",
  null
  
)

export default component.exports